export default "__VITE_ASSET__BaykqfuE__"